import { AxiosRequestConfig } from "axios";
import { AXIOS_INSTANCE, BASE_URL } from "../App";
import { CustomerReturn } from "../../../dist/utils/reco/runners";

export interface EquipmentAndRecommendation {
  cmap: any; // Vending visualizer
  reco: any; // Recommended vending visualizer
  allMats: any; // Materials for active in machine
  kpis: any; // Dumb dumb want gum gum
  callouts: any[];
  cols: any[];
  local?: any[];
  columns?: any;
  info?: any;
  errorMessage?:any;
}


export default async function ProvideRecommendation(
  salesOrg: string,
  cusnum: string,
  newFlavors: boolean,
  maxFlavors: boolean,
  useBrandflowOpt: boolean,
  fullRec: boolean,
  sliderValue?: any,
  numSettlements?: number,
  sales_office?:string,
  recoByPlant?:boolean
): Promise<CustomerReturn> {
  let params: any = {
    clientId: "100",
    salesOrg: salesOrg,
    customerNum: cusnum,
    numSettlements,
    newFlavors,
    maxFlavors,
    useBrandflowOpt,
    fullRec,
    sales_office,
    recoByPlant
  };

  params.startDate = sliderValue && sliderValue[0];
  params.endDate = sliderValue && sliderValue[1];

  const recoConf: AxiosRequestConfig = {
    method: "GET",
    params,
    url: `${BASE_URL}/api/recommendation/rework`,
  };

  const rec = await AXIOS_INSTANCE(recoConf)
    .then((v) => v.data)
    .catch((err) => console.error(err));

  return { ...rec };
}
export  async function GetEquipmentPlanogramInfoActual(
  salesOrg: string,
  cusnum: string,
  newFlavors: boolean,
  maxFlavors: boolean,
  useBrandflowOpt: boolean,
  fullRec: boolean,
  sliderValue?: any,
  numSettlements?: number,
  sales_office?:string,
  recoByPlant?:boolean
): Promise<CustomerReturn> {
  let params: any = {
    clientId: "100",
    salesOrg: salesOrg,
    customerNum: cusnum,
    numSettlements,
    newFlavors,
    maxFlavors,
    useBrandflowOpt,
    fullRec,
    sales_office,
    recoByPlant
  };

  params.startDate = sliderValue && sliderValue[0];
  params.endDate = sliderValue && sliderValue[1];

  const recoConf: AxiosRequestConfig = {
    method: "GET",
    params,
    url: `${BASE_URL}/api/recommendation/equipment_planogram`,
  };

  const rec = await AXIOS_INSTANCE(recoConf)
    .then((v) => v.data)
    .catch((err) => console.error(err));

  return { ...rec };
}

export async function GetInBank(salesOrg: string, cusnum: string) {
  let params: any = {
    clientId: "100",
    salesOrg: salesOrg,
    customerNum: cusnum,
  };

  const bConf: AxiosRequestConfig = {
    method: "GET",
    params,
    url: `${BASE_URL}/api/recommendation/info/bank`,
  };

  const binfo = await AXIOS_INSTANCE(bConf)
    .then((v) => v.data)
    .catch((err) => console.error(err));

  return binfo;
}

export async function ProvideBankRecommendation(salesOrg: string, customer_num: string, maxFlavors: boolean,sales_office:string,recoByPlant?:boolean) {
  let params = {
    clientId: 100,
    salesOrg,
    customerNum: customer_num,
    numSettlements: 6,
    maxFlavors,
    sales_office,
    recoByPlant
  };

  const recoConf: AxiosRequestConfig = {
    method: "GET",
    params,
    url: `${BASE_URL}/api/recommendation/bank`,
  };

  const rec = await AXIOS_INSTANCE(recoConf)
    .then((v) => v.data)
    .catch((err) => console.error(err));

  return rec;
}
export async function ProvideBankOverviewRecommendation(salesOrg: string, customer_num: string, maxFlavors: boolean) {
  let params = {
    clientId: 100,
    salesOrg,
    customerNum: customer_num,
    numSettlements: 6,
    maxFlavors,
  };

  const recoConf: AxiosRequestConfig = {
    method: "GET",
    params,
    url: `${BASE_URL}/api/recommendation/bank/bankoverview`,
  };

  const rec = await AXIOS_INSTANCE(recoConf)
    .then((v) => v.data)
    .catch((err) => console.error(err));

  return rec;
}

export async function GetRecoEnableByPlant(salesOrg: string) {
  let params: any = {
    clientId: "100",
    salesOrg: salesOrg,
  };

  const bConf: AxiosRequestConfig = {
    method: "GET",
    params,
    url: `${BASE_URL}/api/recommendation/recoByPlant`,
  };

  const binfo = await AXIOS_INSTANCE(bConf)
    .then((v) => v.data)
    .catch((err) => console.error(err));

  return binfo;
}
